import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aliver_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const PRICES = {
  oneTime: { key: "aliver_one_time", amount: "£19.99", label: "One-Time Purchase" },
  subscription: { key: "aliver_subscription", amount: "£14.99", label: "Subscribe & Save" },
};

export async function startCheckout(lookupKey) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Something went wrong. Please try again.";
}
